export function getMissionAccountFilter({ missionOrganizationSharing, }) {
    const missionAccountFilter = [{ column: 'systemStatus', op: '=', value: 'active' }];
    if (Array.isArray(missionOrganizationSharing) && missionOrganizationSharing.length) {
        missionAccountFilter.push({
            column: 'orgMembership',
            op: 'overlap',
            value: missionOrganizationSharing,
        });
    }
    return missionAccountFilter;
}
